module.exports = __webpack_public_path__ + "img/grid.7ea85612.svg";